import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BsPlusCircleFill } from 'react-icons/bs';
import { CiEdit } from 'react-icons/ci';
import { RiDeleteBin5Line, RiGalleryUploadLine } from 'react-icons/ri';


interface slider{
  id:number,
  image:string,
}

const Gallery = () => {
    const [selectedPostId, setSelectedPostId] = useState<string | null>(null);
    const [sliderdata, setSliderdata] = useState<slider[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [eventsList, setEventsList] = useState<any[]>([]);
    const [selectedEventFilter, setSelectedEventFilter] = useState<string>('ALL');

    useEffect(() => {
      axios.get('https://rmbbackend.rmbjaipur.com/auth/events')
        .then(res => {
          const list = Array.isArray(res.data) ? res.data : (res.data?.events || res.data?.data || []);
          setEventsList(list);
        })
        .catch(err => console.error("Error fetching events in Gallery:", err));
    }, []);

    // Open modal
    const openModal = (postId: string) => {
      setSelectedPostId(postId);
      setIsModalOpen(true);
    };
  
    // Function to close modal and clear the post ID
    const closeModal = () => {
      setSelectedPostId(null);
      setIsModalOpen(false);
    };
  
    const deletePost = async (id: any) => {
      if (!id) {
        alert('Invalid ID. Cannot delete.');
        return;
      }
      const confirmation = window.confirm('Are you sure you want to delete this image?');
      if(!confirmation){
        return;
      }
    
      try {
        await axios.delete(`https://rmbbackend.rmbjaipur.com/auth/gallery/${id}`);
        alert('Image deleted successfully!');
        window.location.reload();
      } catch (error) {
        console.error('Error deleting image:', error);
        alert('Failed to delete the image. Please try again later.');
      }
    };
    
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get<slider[]>(
            "https://rmbbackend.rmbjaipur.com/auth/gallery"
          );
          setSliderdata(response.data);
        } catch (error) {
          console.error("Gallery Not Found:", error);
        }
      };
  
      fetchData();
    }, []);

  const filteredSliderData = sliderdata.filter((item: any) => {
    if (selectedEventFilter !== 'ALL' && (item.event_id || '').toString() !== selectedEventFilter) {
      return false;
    }
    return true;
  });

  return (
    <div className='p-4 space-y-4'>
      <div className='w-full'>
        <div className="flex flex-wrap items-center justify-between gap-4 bg-white p-4 rounded-xl shadow-sm border">
          <div className='flex justify-center w-[130px] cursor-pointer h-[42px] px-3 py-2 bg-[#FDBC12] text-[#0A2451] font-bold items-center rounded-lg gap-2 shadow hover:bg-amber-400 transition' onClick={() => openModal('')}>
            <BsPlusCircleFill/> <h6>Add New</h6>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-slate-700 uppercase">📅 Filter Gallery by Event:</span>
            <select
              value={selectedEventFilter}
              onChange={(e) => setSelectedEventFilter(e.target.value)}
              className="py-2 px-3 border border-slate-300 rounded-lg text-xs font-bold text-[#0A2451] bg-white outline-none focus:ring-2 focus:ring-[#FDBC12]"
            >
              <option value="ALL">All Events Gallery</option>
              {eventsList.map((evt) => (
                <option key={evt.id} value={evt.id.toString()}>
                  {evt.heading} ({evt.start_date})
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mt-4">
          {filteredSliderData.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {filteredSliderData.map((item: any) => (
                <div key={item.id} className='bg-white rounded-lg p-2 drop-shadow-md border border-slate-100 flex flex-col justify-between'>
                  <img
                    className="h-40 object-cover flex justify-center items-center w-full max-w-full rounded-lg mb-2"
                    src={
                      item.image
                        ? item.image.startsWith("http")
                          ? item.image
                          : `https://rmbbackend.rmbjaipur.com/${item.image}`
                        : "https://via.placeholder.com/150"
                    }
                    alt={item.image || "Gallery Image"}
                  />

                  {item.event_heading && (
                    <span className="text-[10px] bg-blue-50 text-blue-800 font-bold px-2 py-0.5 rounded border border-blue-200 mb-2 truncate">
                      📌 {item.event_heading}
                    </span>
                  )}
                  
                  <div className='flex justify-between gap-4'> 
                    <div className='flex w-full justify-center cursor-pointer py-2 border border-red-600 text-red-600 items-center rounded-lg gap-2 text-xs font-bold hover:bg-red-50 transition' onClick={() => deletePost(item.id)}>
                      <RiDeleteBin5Line/> <h6>Delete Post</h6>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="bg-white p-8 rounded-xl shadow-sm border text-center text-slate-500 font-bold text-sm">
              No gallery photos found matching the selected event filter.
            </div>
          )}
        </div>
      </div>
      

   {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* Close button */}
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <Modal  postId={selectedPostId} onClose={closeModal} />
          </div>
        </div>
      )}
   </div>
  )
}


interface ModalProps {
    postId?: string | null; 
    onClose: () => void;
  }
  
  const Modal: React.FC<ModalProps> = ({ postId, onClose }) => {
  
    
    const [formData, setFormData] = useState({
      image: null as File | null,
      event_id: '' as string,
    });
    const [fileName, setFileName] = useState<string | null>(null);
    const [error, setError] = useState<string>('');
    const [eventsList, setEventsList] = useState<any[]>([]);

    useEffect(() => {
      axios.get('https://rmbbackend.rmbjaipur.com/auth/events')
        .then(res => {
          const list = Array.isArray(res.data) ? res.data : (res.data?.events || res.data?.data || []);
          setEventsList(list);
        })
        .catch(err => console.error("Error fetching events:", err));
    }, []);
  
    useEffect(() => {
      if (postId) {
        const fetchPost = async () => {
          try {
            const response = await axios.get(`https://rmbbackend.rmbjaipur.com/auth/gallery/${postId}`);
    
  
            const data = Array.isArray(response.data) ? response.data[0] : response.data;
   // Access the first element
    
            // Destructure from the first element of the array
            const {  image: image} = data;
        
    console.log("Image:", image);
    setFormData({
      image: image || null,
      event_id: data.event_id || ''
    });
    
            setFileName(image);
          } catch (err) {
            console.error('Error fetching post:', err);
          }
        };
        fetchPost();
      }
    }, [postId]);
  
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };
  
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0] || null;
      setFormData((prev) => ({ ...prev, image: file }));
      setFileName(file ? file.name : null);
    };
  
    const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
    
      // Validate fields
  
    
    
      const data = new FormData();
      if (formData.image) {data.append('image', formData.image);}
      else if(fileName){
        data.append('image',fileName);
      }
      if (formData.event_id) {
        data.append('event_id', formData.event_id);
      }
  
  
  
      console.log('Data data '+formData.image);
      console.log('filename '+fileName);
    
      console.log('Submitting form data:', {
        image: formData.image,
      });
    
      try {
          await axios.post('https://rmbbackend.rmbjaipur.com/auth/gallery', data, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          console.log('slider created successfully');
        
        onClose();
        window.location.href  = '/dashboard';
      } catch (err: any) {
      console.error('Error submitting post:', err);
      const serverMsg = err.response?.data?.message || err.response?.data?.error || err.message || 'Unknown error';
      setError(`Failed to submit post: ${serverMsg}`);
    }
    };
    
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white w-1/2 p-6 rounded shadow relative">
          
          <form onSubmit={handleSubmit} className="space-y-4">
          
  
  
            
  
            
            {/* Event Selection */}
            <div>
              <label className="text-[#030303] font-medium">Select Event (Optional)</label>
              <select
                name="event_id"
                value={formData.event_id || ''}
                onChange={(e) => setFormData((prev) => ({ ...prev, event_id: e.target.value }))}
                className="w-full mt-1 border px-3 py-2 rounded-lg text-black bg-white focus:outline-none focus:ring-2 focus:ring-[#FDBC12]"
              >
                <option value="">-- No Event / General Gallery --</option>
                {eventsList.map((evt) => (
                  <option key={evt.id} value={evt.id}>
                    {evt.heading} ({evt.start_date})
                  </option>
                ))}
              </select>
            </div>

            {/* File Upload */}
            <div>
              <label className="text-[#030303]  font-medium">  Add media</label>
              <div className="mt-1 w-[100%] h-[200px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
             
                <RiGalleryUploadLine size={24} className="text-[30px] cursor-pointer"
                                  onClick={() => document.getElementById('file-upload')?.click()}  />
                <input
                id="file-upload"
                type="file"
                accept="image/*"
                className="hidden"
                name='image'
              
                onChange={handleFileChange}
  
                
              />
              {fileName ? (
    <p className="text-[14px] text-[#02256d] mt-2">
      Selected file: <span className="font-bold">{fileName}</span>
    </p>
  ) : (
    <p className="font-bold text-[14px]">
      Drag and Drop or{' '}
      <span className="text-[#02256d]">click to upload</span>
    </p>
  )}
              </div>
              
            </div>
  
            {/* Error Message */}
            {error && <p className="text-red-500">{error}</p>}
  
  
  <div className=' flex justify-between'>
  
              {/*Cancel form button*/}
              <button className='mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold'  onClick={onClose}>Cancel</button>
               {/* Submit Button */}
            <button
              type="submit"
              className='mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold'
              disabled={!formData.image}
            >
              {postId ? 'Update Image' : 'Add Image'}
            </button>
            </div>
           
  
  
  
  
            
          </form>
        </div>
      </div>
    );
  };
export default Gallery